<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 27V13H25V27H5Z" stroke="white" stroke-width="2"/>
<path d="M9 12V8.66667C9 6.44444 9.4 2 15 2C20.6 2 21 6.44444 21 8.66667V12" stroke="white" stroke-width="2"/>
</svg>
